import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistrationComponent } from './registration.component';
import { RegistrationDetailsComponent } from './registration-details/registration-details.component';
import { BankInfoComponent } from './bank-info/bank-info.component';
import { TCPAndInsuranceComponent } from './tcp-and-insurance/tcp-and-insurance.component';
import { VerificationComponent } from './verification/verification.component';
import { PayoutSetupComponent } from './payout-setup/payout-setup.component';
import { PayoutReturnComponent } from './payout-return/payout-return.component';
import { RegVehiclesComponent } from './vehicles/reg-vehicles.component';
import { RegDriverProfileComponent } from './drivers/reg-driver-profile.component';
import { RegDriverAssignVehicleComponent } from './drivers/reg-driver-assign-vehicle.component';
import { RegDriverVerificationComponent } from './drivers/reg-driver-verification.component';
import { RegDriverBankComponent } from './drivers/reg-driver-bank.component';
import { RegDriverPreviewComponent } from './drivers/reg-driver-preview.component';
import { RegDriverPayoutSetupComponent } from './drivers/reg-driver-payout-setup.component';
import { RegDriverPayoutReturnComponent } from './drivers/reg-driver-payout-return.component';
import { SignupStepGuard } from './signup-step.guard';

const routes: Routes = [
  {
    path: '',
    component: RegistrationComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'registration-details' },
      { path: 'registration-details', component: RegistrationDetailsComponent, canActivate: [SignupStepGuard] },
      { path: 'payout-setup', component: PayoutSetupComponent, canActivate: [SignupStepGuard] },
      { path: 'payout-return', component: PayoutReturnComponent, canActivate: [SignupStepGuard] },
      { path: 'verification', component: VerificationComponent, canActivate: [SignupStepGuard] },
      { path: 'bank-info', redirectTo: 'payout-setup', pathMatch: 'full' },
      { path: 'insurance-details', component: TCPAndInsuranceComponent, canActivate: [SignupStepGuard] },
      { path: 'vehicles', component: RegVehiclesComponent, canActivate: [SignupStepGuard] },
      { path: 'drivers', pathMatch: 'full', redirectTo: 'drivers/profile-details' },
      { path: 'drivers/profile-details', component: RegDriverProfileComponent, canActivate: [SignupStepGuard] },
      { path: 'drivers/assign-vehicle', component: RegDriverAssignVehicleComponent, canActivate: [SignupStepGuard] },
      { path: 'drivers/verification', component: RegDriverVerificationComponent, canActivate: [SignupStepGuard] },
      { path: 'drivers/payout-setup', component: RegDriverPayoutSetupComponent, canActivate: [SignupStepGuard] },
      { path: 'drivers/payout-return', component: RegDriverPayoutReturnComponent, canActivate: [SignupStepGuard] },
      { path: 'drivers/bank-information', redirectTo: 'drivers/payout-setup', pathMatch: 'full' },
      { path: 'drivers/preview', component: RegDriverPreviewComponent, canActivate: [SignupStepGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [SignupStepGuard]
})
export class RegistrationRoutingModule {}
